import styled from '@emotion/styled';
import { Variables } from '../base';

export const MissingId = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 32px;
    padding: 0 12px;
    background-color: ${Variables.Colors.n15_48};
    border: 1px solid ${Variables.Colors.n15};
    border-radius: 8px;
    font: var(--label-md, 500 14px/1.2 Calibre, sans-serif);
    color: ${Variables.Colors.n70};
    white-space: nowrap;
`;

export const Message = styled.div`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;
